import { render, staticRenderFns } from "./PasswordResetUser.vue?vue&type=template&id=94983d12&"
import script from "./PasswordResetUser.vue?vue&type=script&lang=js&"
export * from "./PasswordResetUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports